import { UserComponent } from '@user/user.component';
import { AdminListComponent } from './../administrator/admin-list/admin-list.component';
import { LeaderListComponent } from './../leader/leader-list/leader-list.component';
import { AnalystListComponent } from './../analyst/analyst-list/analyst-list.component';
import { CustomerListComponent } from './../customer/customer-list/customer-list.component';
import { LeaderComponent } from './../leader/leader.component';
import { AnalystComponent } from './../analyst/analyst.component';
import { CustomerComponent } from './../customer/customer.component';
import { CompanyComponent } from '@company/company.component';
import { AdministratorComponent } from './../administrator/administrator.component';
import { DashboardComponent } from './../dashboard/dashboard.component';
import { HomeComponent } from './home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserFormComponent } from '@user/user-form/user-form.component';
import { CompanyFormComponent } from '@company/company-form/company-form.component';
import { CompanyListComponent } from '@company/company-list/company-list.component';
import { ModuleComponent } from '@module/module.component';
import { CompanyModuleComponent } from '@module/company-module/company-module.component';
import { LinkGroupsComponent } from '@module/company-module/link-groups/link-groups.component';

import { tableauRoutes } from '@base/tableau-dashboard/tableau-dashboard.routing';

// resolvers
import { HomeResolver } from './home.resolver';
import { UserResolver } from '@user/user.resolver';
import { CompanyResolver } from '@company/company.resolver';

import { ROLES } from '@utils';
import { EtlComponent } from '@base/etl/etl.component';
import { RoleComponent } from '@base/role/role.component';
import { RoleListComponent } from '@base/role/list/list.component';
import { RoleFormComponent } from '@base/role/form/form.component';
import { DetailsComponent } from '@etl/details/details.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    resolve: { data: HomeResolver },
    children: [
      {
        path: '',
        component: DashboardComponent
      },
      {
        path: ROLES.ADMIN,
        component: AdministratorComponent,
        resolve: { data: UserResolver },
        children: [
          {
            path: '',
            component: AdminListComponent
          },
          {
            path: ':id',
            component: UserFormComponent
          }
        ]
      },
      {
        path: ROLES.LEADER,
        component: LeaderComponent,
        resolve: { data: UserResolver },
        children: [
          {
            path: '',
            component: LeaderListComponent
          },
          {
            path: ':id',
            component: UserFormComponent
          }
        ]
      },
      {
        path: ROLES.ANALYST,
        component: AnalystComponent,
        resolve: { data: UserResolver },
        children: [
          {
            path: '',
            component: AnalystListComponent
          },
          {
            path: ':id',
            component: UserFormComponent
          }
        ]
      },
      {
        path: ROLES.CUSTOMER,
        component: CustomerComponent,
        resolve: { data: UserResolver },
        children: [
          {
            path: '',
            component: CustomerListComponent
          },
          {
            path: ':id',
            component: UserFormComponent
          }
        ]
      },
      {
        path: 'users',
        component: UserComponent,
        children: [
          {
            path: 'register',
            component: UserFormComponent,
          }
        ]
      },
      {
        path: 'companies',
        component: CompanyComponent,
        resolve: { data: CompanyResolver },
        children: [
          {
            path: '',
            component: CompanyListComponent
          },
          {
            path: 'add',
            component: CompanyFormComponent
          },
          {
            path: ':id',
            component: CompanyFormComponent
          }
        ]
      },
      {
        path: 'modules',
        component: ModuleComponent,
        children: [
          {
            path: ':id',
            component: CompanyModuleComponent,
          },
          {
            path: ':id/tableau/:companyId',
            component: LinkGroupsComponent,
          },
          {
            path: ':id/etl/:companyId',
            component: EtlComponent,
          },
          {
            path: ':id/etl/:companyId/job/:jobId',
            component: DetailsComponent,
          },
        ]
      },
      // rutas para mostrar modulo de Reportes a Clientes
      tableauRoutes[0],
      {
        path: 'roles',
        component: RoleComponent,
        children: [
          {
            path: '',
            component: RoleListComponent
          },
          {
            path: 'add',
            component: RoleFormComponent
          },
          {
            path: ':id',
            component: RoleFormComponent
          }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
    ],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
